// import * as React from 'react';
import { sessionStorageKeys, SIGN_IN_HOST_PATH } from '../constants/general';
// // Common Utilities
export const windowExists = () => typeof window !== 'undefined';
export const THD_CUSTOMER = () => {
    var _a;
    return typeof window !== 'undefined'
        ? (_a = window === null || window === void 0 ? void 0 : window.THDCustomer) === null || _a === void 0 ? void 0 : _a.default
        : { role: '' };
};
export const getUserRole = () => {
    var _a;
    return ((_a = THD_CUSTOMER()) === null || _a === void 0 ? void 0 : _a.role) || 'PURCHASER';
};
export const gatherAllParamsToString = (prefix = '') => {
    var _a, _b;
    const urlParams = new URLSearchParams(window.location.search);
    const entriesListStringified = (_b = (_a = Array.from(urlParams === null || urlParams === void 0 ? void 0 : urlParams.entries())) === null || _a === void 0 ? void 0 : _a.map((entry) => `${entry[0]}=${entry[1]}`)) === null || _b === void 0 ? void 0 : _b.join('&');
    if (!entriesListStringified)
        return '';
    return `${prefix}${entriesListStringified}`;
};
const clearSessionStorageRVData = () => {
    sessionStorage.removeItem(sessionStorageKeys.recentlyViewedItems);
    sessionStorage.removeItem(sessionStorageKeys.recentlyViewedDatestamp);
};
const redirectToLogon = (url = '') => {
    let redirectTo = '';
    const params = gatherAllParamsToString('&');
    if (url)
        redirectTo = `?redirect=${url}${params}`;
    clearSessionStorageRVData();
    window.location.href = `${SIGN_IN_HOST_PATH}${redirectTo !== '' ? redirectTo : ''}`;
};
export const gotoLogonModule = () => {
    const redirectTo = window.location.pathname;
    redirectToLogon(redirectTo);
};
// Safe TMX session ID retrieval
export const getTMXSessionId = () => {
    var _a, _b;
    try {
        return ((_b = (_a = window.THD_ACCOUNT_LIB) === null || _a === void 0 ? void 0 : _a.TMX) === null || _b === void 0 ? void 0 : _b.getTMXsessionId()) || '';
    }
    catch (error) {
        return '';
    }
};
export const determineMembershipLevel = (rewardsAndOffers) => {
    var _a, _b;
    const tierName = (_b = (_a = rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.proTiers) === null || _a === void 0 ? void 0 : _a.currentTierName) === null || _b === void 0 ? void 0 : _b.toUpperCase();
    if (tierName === 'MEMBER' || tierName === 'ELITE' || tierName === 'VIP') {
        return tierName;
    }
    return 'MEMBER';
};
export const getBenefitTag = (rewardsAndOffers, tagName) => {
    var _a, _b;
    const benefitTags = (_a = rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.proTiers) === null || _a === void 0 ? void 0 : _a.benefitTags;
    const benefit = benefitTags === null || benefitTags === void 0 ? void 0 : benefitTags.find((tag) => tag.tagName === tagName);
    return { tag: benefit, value: (_b = benefit === null || benefit === void 0 ? void 0 : benefit.value) === null || _b === void 0 ? void 0 : _b.toLowerCase() };
};
